//#region IMPORT
/** Components Import */
import { Box, Unstable_Grid2 as Grid, Stack, Typography } from '@mui/material';
import { AuthButton, Button, Dialog } from '../../../../Components/MUIs';
/** AG-grid Import */
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import DaumPostcode from 'react-daum-postcode';
import {
  getColumnDefs1,
  getColumnDefs2,
  getColumnDefs3,
  getColumnDefs4,
} from './PLA_BASIC_ColumnDefs';
/** Icons Import */
import { BusinessCommon } from '../../../../Components/BusinessCommon';
import safeonJourneyman1 from '../../../../Assets/Images/safeOn_journeyman1.png';
import safeonJourneyman2 from '../../../../Assets/Images/safeOn_journeyman2.png';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { useDispatch, useSelector } from 'react-redux';
import {
  setSearchText,
  setModalSearchText,
} from '../../../../Reducer/SearchReducer';

//#endregion
function PLA_BASIC(props) {
  //#region 변수
  const gridState1 = useSelector((state) => state.grid.grid1);

  const dispatch = useDispatch();
  // 사업장정보 컬럼
  const columnDefs1 = getColumnDefs1(props);
  //업종 그리드 컬럼
  const columnDefs2 = getColumnDefs2();
  //관리자 관리 그리드 컬럼
  const columnDefs3 = getColumnDefs3(props);
  //관리자 관리 안 관리자ID 그리드 컬럼
  const columnDefs4 = getColumnDefs4();
  //#endregion

  //#region 함수

  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Plant"
          searchYn="Y"
          saveYn="Y"
          printYn="N"
          saveClick={() => props.SaveLogic5()}
          searchClick={(e) => {
            dispatch(setSearchText(e));
            props.gridRef1.current.api.setQuickFilter(e);
          }}
          grids={
            <BusinessCommon
              gridId={props.gridId1}
              getRowId={(params) => {
                return params.data.no;
              }}
              addYn1={props.userInfo.authCd === 'HEAD_MANAGER' ? 'N' : 'Y'}
              deleteYn1={props.userInfo.authCd === 'HEAD_MANAGER' ? 'N' : 'Y'}
              addClick1={() => {
                props.HandleAddClick(props.gridRef1);
              }}
              deleteClick1={(e) => {
                const newRowExists = props.selectedRowData.some(
                  (row) => row.newYn === 'Y'
                );
                if (!newRowExists) {
                  props.MarkedForDeletion(props.selectedRowData);
                } else {
                  props.NewYnErrorMsg();
                  props.inputRef.current?.focus();
                }
              }}
              saveClick1={() => props.SaveLogic1()}
              refreshClick1={() => {
                props.SearchLogic1();
              }}
              title1={'사업장정보'}
              title2={'사업장정보(입력란)'}
              gridRef={props.gridRef1}
              columnDefs={columnDefs1}
              rowData={gridState1?.rowData}
              rowSelection="multiple"
              rowMultiSelectWithClick={true}
              setSelectedRowData={props.setSelectedRowData}
              setChangedRowData={props.setChangedRowData}
              tableData={props.tableData}
              colWidth={props.colWidth}
              suppressRowClickSelection={true}
              onCellClicked={(e) => {
                // 필요 시 특정 행 선택 등 처리
                const gridApi = props.gridRef1.current.api;
                const clickedRowIndex = e.rowIndex;

                const isCheckboxClick = e.event?.target?.type === 'checkbox';

                if (!isCheckboxClick) {
                  gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
                  gridApi.setFocusedCell(clickedRowIndex, 'custNm');

                  const copied = JSON.parse(JSON.stringify(e.data));
                  props.handleRowSelection(copied, clickedRowIndex);

                  gridApi
                    .getDisplayedRowAtIndex(clickedRowIndex)
                    ?.setSelected(true, false);
                }
              }}
              onSelectionChanged={() => {
                const gridApi = props.gridRef1?.current?.api;
                const selectedNodes = gridApi.getSelectedNodes();
                const selectedData = selectedNodes.map((n) => n.data);

                props.selectedRowNosRef.current = new Set(
                  selectedData.map((r) => r.no)
                );
                props.setSelectedRowData(selectedData);
              }}
            />
          }
        />
      </Grid>
      <input
        type="file"
        key={props.inputKey}
        ref={props.fileInputRef}
        style={{ display: 'none' }}
        accept={props.fileType === '0' ? 'video/mp4' : 'application/pdf'}
        onChange={(e) => {
          props.FileChange(e);
        }}
      />
      <Dialog
        open={props.openAddressDialog}
        onClose={props.HandleCloseAddressDialog}
        title={'주소'}
        fullWidth
        content={<DaumPostcode onComplete={props.HandleAddressSelect} />}
        closeButtonName={'닫기'}
        useCloseButton={(e) => props.HandleCloseAddressDialog}
      />
      {/* 업종코드 팝업 창 */}
      {props.modalToggle1 && (
        <Dialog
          title="업종 설정"
          open={props.modalToggle1}
          onClose={(e) => {
            props.setModalToggle1(false);
            dispatch(setModalSearchText(''));
          }}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          fullWidth
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={true}
          useSaveAfterClose={true}
          onSave={() => {
            if (
              props.selectedModalRowData1 &&
              props.selectedModalRowData1.length > 0
            ) {
              const row = props.selectedModalRowData1?.[0];
              if (row) {
                const fields = [
                  ['indCd', 'indCd'],
                  ['industrialMain', 'industrialMain'],
                  ['industrialSub', 'industrialSub'],
                  ['industrialSmall', 'industrialSmall'],
                ];

                const updatedInputs = fields.reduce(
                  (acc, [name, key]) => {
                    acc[name] = row[key];
                    return acc;
                  },
                  { ...props.inputs, newYn: 'Y' }
                );

                props.setInputs(updatedInputs);

                fields.forEach(([name, key]) => {
                  props.updateCurrentRowData(name, row[key]);
                });
              }
            }

            dispatch(setModalSearchText(''));
          }}
          maxWidth="lg"
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{ height: '600px', width: '100%' }}
            >
              <AuthButton
                menuId="Plant"
                searchYn="Y"
                saveYn="N"
                printYn="N"
                searchClick={(e) => {
                  dispatch(setModalSearchText(e));
                  props.gridRef2.current.api.setQuickFilter(e);
                }}
                grids={
                  <AgGridReact
                    ref={props.gridRef2}
                    animationRows={true}
                    columnDefs={columnDefs2}
                    rowData={props.modalRowData1}
                    defaultColDef={{
                      minWidth: 100,
                      editable: true,
                      resizable: true,
                      sortable: true,
                      filter: true,
                      floatingFilter: true,
                    }}
                    rowSelection="single"
                    onSelectionChanged={() => {
                      GridFunctions.onSelectionChanged(
                        props.gridRef2,
                        (_selected) => {
                          props.setSelectedModalRowData1(_selected);
                        }
                      );
                    }}
                    getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                    // onRowDoubleClicked={(e) => {
                    //   props.setModalToggle1(false); // 모달 닫기

                    //   setTimeout(() => {
                    //     handleDepartmentSelection(e.data);
                    //   }, 100);
                    // }}
                    pagination={true}
                    paginationPageSize={100} // sets 10 rows per page (default is 100)
                    paginationPageSizeSelector={[100, 200, 500, 1000]} // allows the user to select the page size from a predefined list of page sizes
                    localeText={{
                      // 기본 텍스트
                      page: '페이지',
                      more: '더보기',
                      to: '~',
                      of: '/',
                      next: '다음',
                      last: '마지막',
                      first: '처음',
                      previous: '이전',
                      loadingOoo: '불러오는 중...',

                      // 필터 & 패널 등
                      selectAll: '전체 선택',
                      searchOoo: '검색...',
                      blanks: '공백',

                      // 페이지 사이즈 선택기
                      pageSizeSelectorLabel: '페이지 당 행 수',

                      // 기본 페이지네이션 설명
                      paginationPageSize: '페이지 당 행 수',
                      paginationNumberFormatter: (params) => `${params.value}`,
                    }}
                    tooltipShowDelay={300}
                    tooltipHideDelay={1500}
                  />
                }
              />
            </div>
          }
        />
      )}
      {/* 관리자 관리 팝업 창 */}
      {props.modalToggle3 && (
        <Dialog
          title="관리자 설정"
          open={props.modalToggle3}
          onClose={(e) => props.setModalToggle3(false)}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          fullWidth
          saveButtonName="저장"
          closeButtonName="닫기"
          useSaveButton={true}
          useSaveAfterClose={false}
          onSave={() => {
            props.SaveLogic3();
          }}
          maxWidth="md"
          actions={
            <>
              <Button
                name="추가"
                onClick={() => {
                  GridFunctions.addClick(props.gridRef3);
                }}
                sx={{
                  color: '#fff',
                  backgroundColor: '#2CA900',
                }}
                size={'small'}
              />
            </>
          }
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{ height: '600px', width: '100%' }}
            >
              <AgGridReact
                ref={props.gridRef3}
                animationRows={true}
                columnDefs={columnDefs3}
                rowData={props.modalRowData3}
                defaultColDef={{
                  minWidth: 100,
                  editable: true,
                  resizable: true,
                  sortable: true,
                  filter: true,
                  floatingFilter: true,
                }}
                rowSelection="single"
                onSelectionChanged={() => {
                  GridFunctions.onSelectionChanged(
                    props.gridRef3,
                    (_selected) => {
                      props.setSelectedModalRowData3(_selected);
                    }
                  );
                }}
                onCellValueChanged={(e) => {
                  GridFunctions.onCellValueChanged(
                    e,
                    props.gridRef3,
                    props.setChangedModalRowData3
                  );
                }}
                stopEditingWhenCellsLoseFocus={true} //마우스로 외부 클릭 시 cell 닫힘
              />
            </div>
          }
        />
      )}
      {/* 관리자 관리 내부 ID 설정 팝업 창 */}
      {props.modalToggle4 && (
        <Dialog
          title="ID 설정"
          open={props.modalToggle4}
          onClose={(e) => props.setModalToggle4(false)}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          fullWidth
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={true}
          useSaveAfterClose={true}
          onSave={() => {
            if (props.gridRef3.current) {
              const rowNode = props.gridRef3.current.api.getRowNode(
                props.clickRowId3.node.id
              );
              if (rowNode) {
                // 중복검사
                const isDuplicate = props.modalRowData3.some(
                  (row) => row.cmId === props.selectedModalRowData4[0].id
                );
                if (isDuplicate) {
                  dispatch(
                    showSnackbar({
                      message: '중복된 ID 입니다.',
                      type: 'warning',
                    })
                  );
                  return;
                }
                rowNode.setDataValue('cmId', props.selectedModalRowData4[0].id);
                rowNode.setDataValue('ceo', props.selectedModalRowData4[0].ceo);
                rowNode.setDataValue(
                  'cmTel',
                  props.selectedModalRowData4[0].tel
                );
                rowNode.setDataValue(
                  'cmBirth',
                  props.selectedModalRowData4[0].birth
                );
              }
            }
          }}
          maxWidth="md"
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{ height: '600px', width: '100%' }}
            >
              <AgGridReact
                ref={props.gridRef4}
                animationRows={true}
                columnDefs={columnDefs4}
                rowData={props.modalRowData4}
                defaultColDef={{
                  minWidth: 100,
                  editable: true,
                  resizable: true,
                  sortable: true,
                  filter: true,
                  floatingFilter: true,
                }}
                rowSelection="single"
                onSelectionChanged={() => {
                  GridFunctions.onSelectionChanged(
                    props.gridRef4,
                    (_selected) => {
                      props.setSelectedModalRowData4(_selected);
                    }
                  );
                }}
                onRowDoubleClicked={(params) => {
                  // 더블클릭 시 선택된 행으로 설정
                  if (params.data) {
                    props.setSelectedModalRowData4([params.data]);
                    // onSave 로직 실행
                    if (props.gridRef3.current) {
                      const rowNode = props.gridRef3.current.api.getRowNode(
                        props.clickRowId3.node.id
                      );
                      if (rowNode) {
                        // 중복검사
                        const isDuplicate = props.modalRowData3.some(
                          (row) => row.cmId === params.data.id
                        );
                        if (isDuplicate) {
                          dispatch(
                            showSnackbar({
                              message: '중복된 ID 입니다.',
                              type: 'warning',
                            })
                          );
                          return;
                        }
                        rowNode.setDataValue('cmId', params.data.id);
                        rowNode.setDataValue('ceo', params.data.ceo);
                        rowNode.setDataValue('cmTel', params.data.tel);
                        rowNode.setDataValue('cmBirth', params.data.birth);
                        // 팝업 닫기
                        props.setModalToggle4(false);
                      }
                    }
                  }
                }}
                stopEditingWhenCellsLoseFocus={true} //마우스로 외부 클릭 시 cell 닫힘
              />
            </div>
          }
        />
      )}
      {/* 직인 예시 팝업 */}
      {props.modalToggle8 && (
        <Dialog
          title={'직인 예시'}
          titleSx={{ fontSize: '24px' }}
          open={props.modalToggle8}
          onClose={(e) => {
            props.setImageFile({
              ...props.imageFile,
              journeyFiles: '',
              journeyImage: '',
            });
            props.setModalToggle8(false);
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            height: '20vh',
          }}
          fullWidth
          useSaveButton={true}
          useCloseButton={false}
          saveButtonName={'확인'}
          closeButtonName={''}
          useSaveAfterClose={false}
          onSave={() => {
            props.setModalToggle8(false);
          }}
          maxWidth="sm"
          btnSx={{ width: '120px', height: '60px' }}
          content={
            <Box
              className="ag-theme-alpine no-scroll"
              style={{
                width: '100%',
                height: '100%',
                alignContent: 'center',
              }}
            >
              <Typography sx={{ fontSize: '14px', mb: 2 }}>
                직인의 배경은 흰색 또는 투명해야 합니다.
              </Typography>
              <Stack
                direction="row"
                spacing={8}
                sx={{
                  display: 'flext',
                  justifyContent: 'center',
                  alignContent: 'center',
                }}
              >
                <img
                  src={safeonJourneyman1}
                  style={{
                    maxWidth: '25%',
                    objectFit: 'contain',
                  }}
                />
                <img
                  src={safeonJourneyman2}
                  style={{
                    maxWidth: '25%',
                    objectFit: 'contain',
                  }}
                />
              </Stack>
            </Box>
          }
        />
      )}
    </Grid>
  );
}

export default PLA_BASIC;
